import React from 'react';
import PropTypes from 'prop-types';
import Radio from './Radio';

const RadioGroup = ({
  disabled,
  horizontal,
  name,
  options,
  value,
  onBlur,
  onChange,
}) => <>
    {options.map((option, idx) => {
      const { optionDisabled, id, value: optionValue, ...rest } = option;
      return (
        <Radio
          checked={value === optionValue}
          disabled={disabled || optionDisabled}
          horizontal={horizontal}
          id={id}
          key={`${id}-${idx}`}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          value={optionValue}
          {...rest}
        />
      );
    })}
  </>

export default RadioGroup;

RadioGroup.propTypes = {
  disabled: PropTypes.bool,
  horizontal: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      id: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

RadioGroup.defaultProps = {
  disabled: false,
  horizontal: false,
  options: [],
};
